module.exports = new __parcel__URL__("Druideskill_36.26c4803d.png").toString();